export class ExportColumn {
    public key:string;
    public name:string;
    public enabled:boolean;

    constructor(key,name) {
        this.key = key;
        this.name = name;
        this.enabled = true;
    }
}